export default "__VITE_ASSET__87IvhN6C__"